module.exports = __webpack_public_path__ + "static/img/5.0a9ba7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/5.png
// module id = j1c3
// module chunks = 0